import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Donate from "./pages/Donate";
import Adopt from "./pages/Adopt";
import Stories from "./pages/Stories";
import StoryDetail from "./pages/StoryDetail";
import Contact from "./pages/Contact";
import Give from "./pages/Give";
import Terms from "./pages/policies/Terms";
import Privacy from "./pages/policies/Privacy";
import RefundPolicy from "./pages/policies/RefundPolicy";
import ShippingPolicy from "./pages/policies/ShippingPolicy";
import NotFound from "./pages/NotFound";

const TOASTER_OPTIONS = {
  style: {
    background: '#F9F6F0',
    color: '#1E3B27',
    border: '1px solid #E5E0D8',
    fontFamily: 'Manrope, sans-serif',
  },
};

function App() {
  return (
    <div className="App paper-texture">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="donate" element={<Donate />} />
            <Route path="give" element={<Give />} />
            <Route path="adopt" element={<Adopt />} />
            <Route path="stories" element={<Stories />} />
            <Route path="stories/:storyId" element={<StoryDetail />} />
            <Route path="contact" element={<Contact />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="shipping-policy" element={<ShippingPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={TOASTER_OPTIONS} />
    </div>
  );
}

export default App;
